import { render, staticRenderFns } from "./math-lessons.vue?vue&type=template&id=81943472&scoped=true&"
import script from "./math-lessons.vue?vue&type=script&lang=js&"
export * from "./math-lessons.vue?vue&type=script&lang=js&"
import style0 from "./math-lessons.vue?vue&type=style&index=0&id=81943472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81943472",
  null
  
)

export default component.exports